module.exports = __webpack_public_path__ + "static/media/shop_type_6.2d5d2e98.png";